import classNames from 'classnames'
import { ElDivider } from 'element-plus'
import type { FunctionalComponent } from 'vue'
import './HocElDivider.scss'

type ElDividerProps = InstanceType<typeof ElDivider>['$props']

export const HocElDivider: FunctionalComponent<ElDividerProps> = (_props, { slots, attrs }) => {
  return (
    <ElDivider {...attrs} class={classNames('hoc-el-divider', attrs.class as string)}>
      {slots}
    </ElDivider>
  )
}
HocElDivider.inheritAttrs = false
